export default __webpack_public_path__ + "static/media/prev-arrow.c32629b8.svg";